const searchParams = {
    externalAccessKey: 'externalAccessKey',
    apiToken: 'apiToken',
    id: 'id',
    accessKey: 'accessKey',
    preview: 'preview',
    activeTab: 'activeTab',
    email: 'email',
    promptBypass: 'promptbypass'
}

export default searchParams;